import React from "react";
import './training-video.scss'
import { Col, Row } from "antd";
import Frame from "../../../assets/images/right-arrow-helpandsupport.svg";
import RightArrow from "../../../assets/images/video-frame.svg";
import { useTranslation } from "react-i18next";

const TrainingVideo = () => {
    const { t } = useTranslation();
    return (
        <div className="training-video-wrapper">
              <a
                href="https://youtu.be/9eEtcLLJKNM?si=eQg-d0UVRaLKM15e"
                target="_blank"
                rel="noopener noreferrer"
                className="training-card-link"
            >
            <div className="training-card">
                <div className="Watch-Tutorial">
                    <div className="step-by-step-guide">
                        <div>{t("TRAINING_VIDEO_STEP_GUIDE")}</div>
                        <div><img src={RightArrow}/></div>
                        </div>
               <Row className="text-row-div">
        <Col  span={16} className="lost-in-text">{t("TRAINING_VIDEO_LOST_APP_TEXT")}</Col>
        <Col span={8} className="image"><img src={Frame}/></Col>
               </Row>
                </div>
            </div>
            </a>
        </div>
    )
}
export default TrainingVideo;